// src/components/SearchInput.js
import React, { useState, useEffect, useRef } from 'react';
import { TextField } from '@mui/material';

const SearchInput = ({ onSearch, placeholder, initialValue = '' }) => {
  const [localValue, setLocalValue] = useState(initialValue);
  const onSearchRef = useRef(onSearch);
  onSearchRef.current = onSearch;

  // Solo ejecutar el debounce cuando cambia localValue (lo que escribe el usuario).
  // No incluir onSearch en dependencias: si no, cada re-render del padre (ej. al cambiar página)
  // crearía una nueva referencia y volvería a llamar onSearch -> setPage(0) en ResidentesTab.
  useEffect(() => {
    const timer = setTimeout(() => {
      onSearchRef.current(localValue);
    }, 400);

    return () => clearTimeout(timer);
  }, [localValue]);

  return (
    <TextField
      fullWidth
      label="Buscar..."
      value={localValue}
      onChange={(e) => setLocalValue(e.target.value)}
      placeholder={placeholder}
      variant="outlined"
      size="small"
    />
  );
};

export default React.memo(SearchInput);
